import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const EarningsWidgetRoot = styled.div`
  width: 100%;
  margin-top: 14px;
  ${typographyV2.bodyBase}
`;
